import { createRoot } from 'react-dom/client';
import "./index.css";
import "./assets/styles/main.scss";
import App from "./App";
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <App />
    <ToastContainer />
  </>
);
